export enum QuotaUsageIndicatorEnum {
    INACTIVE = 'INACTIVE',
    SAFE = 'SAFE',
    HIGH = 'HIGH',
    EXCESSIVE = 'EXCESSIVE',
}
